const styles = theme => ({
  pageTitle: {
    color: 'rgba(12,31,44,0.87)',
    fontFamily: 'Rubik',
    fontSize: '34.54px',
    fontWeight: 500,
    letterSpacing: '0.25px',
    lineHeight: '41px',
    margin: 0,
    marginRight: theme.spacing.unit * 5
  },
  toolBarRootPage: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 5
  },
  actionWrapper: {
    alignItems: 'center',
    display: 'flex',
    flex: 1
  },
  contentOptions: {
    alignItems: 'center',
    display: 'flex',
    height: 24
  },
  iconContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  verticalDivider: {
    width: 1,
    height: '100%',
    backgroundColor: '#000000',
    marginLeft: 17,
    marginRight: 17,
    opacity: 0.12
  },
  actionButton: {
    borderRadius: '2px',
    height: 40,
    padding: 0,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    fontFamily: 'Roboto',
    color: '#F5F5F5',
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    lineHeight: '16px'
  },
  actions: {
    flex: 1,
    justifyContent: 'flex-end',
    display: 'flex'
  },
  buttonsRoot: {
    padding: 0
  },
  filterOptionsWrapper: {
    height: 88,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFF',
    borderRadius: '2px',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    marginBottom: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3
  },
  selectRoot: {
    marginRight: theme.spacing.unit * 2
  },
  filterColor: {
    color: theme.typography.color.main
  }
});

export default styles;
